import React from "react"
import PropTypes from 'prop-types'

import PopoverMenuItem from "src/core/gd-components/popover-menu/popover-menu/menu-item"

export default class GroupMoreMenu extends React.Component {

    static propTypes = {
        menuParams  : PropTypes.object,
        hidePopover : PropTypes.func
    }

    onToggleCollapse = (e) => {
        this.props.menuParams.onToggleCollapse(e)
        this.props.hidePopover()
    }

    render() {
        return (
            <div className="ui5-popover-menu">
                <PopoverMenuItem icon       = {this.props.menuParams.isCollapsed ? "i5-expand" : "i5-collapse"}
                                 label      = {this.props.menuParams.isCollapsed ? 'Expand' : 'Collapse'}
                                 onClick    = {this.onToggleCollapse}/>
            </div>
        )
    }
}